// client/src/api/mt5SchedulerApi.js
import axiosInstance from "./axiosInstance";

const BASE = "/mt5-scheduler";

export function startBot(payload) {
  return axiosInstance.post(`${BASE}/start`, payload);
}

export function stopBot() {
  return axiosInstance.post(`${BASE}/stop`);
}

export function getStatus() {
  return axiosInstance.get(`${BASE}/status`);
}

export function getLogs() {
  return axiosInstance.get(`${BASE}/logs`);
}
